const accountsReducer = (state = 'DEFAULT', action = { type: 'LOGIN_ACCOUNT' }) => {
  switch (action.type) {
    case 'LOGIN_ACCOUNT':
      return 'LOGIN_ACCOUNT'
    case 'RELOAD_ACCOUNT':
      return 'RELOAD'
    case 'ADD_ACCOUNT':
      return 'ADD'
    default:
      return state
  }
}
export default accountsReducer
